export default "__VITE_ASSET__PQ62y9tu__"